import React from 'react';
import { ChevronLeft, ChevronRight, Loader2 } from 'lucide-react';

const HistoryPagination = ({
  groupedItemsLength,
  itemsPerPage,
  currentPage,
  totalPages,
  hasMoreHistory,
  loadingMore,
  onItemsPerPageChange,
  onPaginate,
  onNextPage,
}) => {
  if (!(groupedItemsLength > itemsPerPage || hasMoreHistory || currentPage > 1)) {
    return null;
  }

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const canGoNext = currentPage < totalPages || hasMoreHistory;

  return (
    <div className="flex flex-col sm:flex-row justify-between items-center pt-6 border-t border-hairline gap-4">
      <div className="text-sm text-muted">
        Showing <span className="font-medium">{indexOfFirstItem + 1}</span> to <span className="font-medium">{Math.min(indexOfLastItem, groupedItemsLength)}</span> of <span className="font-medium">{groupedItemsLength}{hasMoreHistory ? '+' : ''}</span> analysis sessions
      </div>
      <div className="flex items-center gap-2">
        <div className="flex items-center mr-4">
          <span className="text-sm text-muted mr-2">Show:</span>
          <select
            value={itemsPerPage}
            onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
            className="text-sm border border-hairline rounded px-2 py-1 outline-none focus:border-brand bg-surface text-ink"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
        </div>
        <nav className="flex items-center gap-1">
          <button
            onClick={() => onPaginate(currentPage - 1)}
            disabled={currentPage === 1}
            className={`p-2 rounded border ${currentPage === 1 ? 'text-muted/40 border-hairline cursor-not-allowed' : 'text-muted border-hairline hover:bg-surface-2'}`}
          >
            <ChevronLeft size={16} />
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter((page) => page === 1 || page === totalPages || Math.abs(page - currentPage) <= 1)
            .map((page, index, array) => (
              <React.Fragment key={page}>
                {index > 0 && array[index - 1] !== page - 1 && (
                  <span className="px-2 text-muted">...</span>
                )}
                <button
                  onClick={() => onPaginate(page)}
                  className={`min-w-[32px] h-8 rounded text-sm font-medium transition-colors ${
                    currentPage === page
                      ? 'bg-brand text-white'
                      : 'text-muted hover:bg-surface-2'
                  }`}
                >
                  {page}
                </button>
              </React.Fragment>
            ))}

          <button
            onClick={onNextPage}
            disabled={!canGoNext || loadingMore}
            className={`p-2 rounded border ${(!canGoNext || loadingMore) ? 'text-muted/40 border-hairline cursor-not-allowed' : 'text-muted border-hairline hover:bg-surface-2'}`}
          >
            {loadingMore ? <Loader2 size={16} className="animate-spin" /> : <ChevronRight size={16} />}
          </button>
        </nav>
      </div>
    </div>
  );
};

export default HistoryPagination;
